import { Controller } from "react-hook-form";
import { FormLabel } from "../FormLabel";
import { FormErrorLabel } from "../FormErrorLabel";
import { Select } from "@/components";

const FormSelect = ({
  name,
  label,
  control,
  error,
  isRequired,
  options,
  onChange,
  ...rest
}: any) => {
  return (
    <div className="relative flex flex-col items-start gap-1">
      {label && (
        <FormLabel>
          {label}{" "}
          {rest?.disabled ? (
            <></>
          ) : (
            <span className="text-red-700">{isRequired ? "*" : ""}</span>
          )}
        </FormLabel>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          return (
            <Select
              options={options}
              {...field}
              {...rest}
              value={rest.multiSelect ? field?.value : field.value?.toString()}
              defaultValue={field.value?.toString()}
              onChange={(value: any) => {
                onChange && onChange(value);
                field.onChange(value);
              }}
            />
          );
        }}
      />
      {error && <FormErrorLabel>{error}</FormErrorLabel>}
    </div>
  );
};

export default FormSelect;
